module.exports = __webpack_public_path__ + "img/page59.e49cce89.gif";